import { RodzajProjektu } from '../rodzajProjektu';
import { ZespolProjektu } from './zespolProjektu';

export class ZespolyProjektu {
  projektId: string;
  nazwaProjektu: string;
  zespoly: Array<ZespolProjektu> = new Array();
  rodzajProjektu: RodzajProjektu;
  czySpisSamodzielnyKlienta: boolean;
}
